import { render } from "./CadastroSinistrosView.vue?vue&type=template&id=ab94371a&scoped=true"
import script from "./CadastroSinistrosView.vue?vue&type=script&lang=js"
export * from "./CadastroSinistrosView.vue?vue&type=script&lang=js"

import "./CadastroSinistrosView.vue?vue&type=style&index=0&id=ab94371a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab94371a"]])

export default __exports__